import React, { useEffect, useState } from "react";
import { useLang } from "@/i18n/LanguageContext";
import { ArrowRight, Bell } from "lucide-react";
import { PRE_HARVEST_MODE } from "@/lib/siteMode";

/**
 * Sticky bottom CTA for mobile viewports (<lg).
 * Hidden once the Shop section (#pedido) is on screen.
 */
export default function StickyMobileCTA() {
  const { t, lang } = useLang();
  const [visible, setVisible] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const mountTimer = setTimeout(() => setMounted(true), 400);
    return () => clearTimeout(mountTimer);
  }, []);

  useEffect(() => {
    const shop = document.getElementById("pedido");
    const footer = document.getElementById("contacto");
    if (!shop) {
      setVisible(true);
      return undefined;
    }
    const io = new IntersectionObserver(
      (entries) => {
        const hideTargets = entries.filter((e) => e.isIntersecting);
        setVisible(hideTargets.length === 0);
      },
      { threshold: 0.1 }
    );
    io.observe(shop);
    if (footer) io.observe(footer);
    return () => io.disconnect();
  }, []);

  const href = PRE_HARVEST_MODE ? "/#pedido" : (lang === "en" ? "/shop" : "/tienda");
  const ctaLabel = PRE_HARVEST_MODE
    ? (lang === "es" ? "Lista de espera" : "Join waitlist")
    : t("mobile_cta.cta");
  const Icon = PRE_HARVEST_MODE ? Bell : ArrowRight;

  return (
    <div
      data-testid="mobile-sticky-cta"
      aria-hidden={!visible}
      className={`fixed bottom-0 inset-x-0 z-40 lg:hidden transition-all duration-500 ${
        mounted && visible
          ? "translate-y-0 opacity-100 pointer-events-auto"
          : "translate-y-full opacity-0 pointer-events-none"
      }`}
    >
      <div className="bg-cream-100/95 backdrop-blur border-t border-cream-400 shadow-[0_-8px_24px_rgba(36,42,29,0.08)]">
        <div className="px-4 py-3 flex items-center justify-end gap-3">
          <a
            href={href}
            data-testid="mobile-sticky-cta-button"
            className="inline-flex items-center gap-2 bg-olive-700 text-cream-100 px-6 py-3 text-[12px] uppercase tracking-[0.26em] hover:bg-olive-800 transition-colors"
          >
            {ctaLabel}
            <Icon size={14} strokeWidth={1.3} />
          </a>
        </div>
      </div>
    </div>
  );
}
